module.exports = __webpack_public_path__ + "static/media/loading8.c49bd878.png";


//////////////////
// WEBPACK FOOTER
// ./src/peaceSharkIndex/index/img/loading/loading8.png
// module id = 193
// module chunks = 0